import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import CssIcon from '../Icon/Icon.js';
import StyledLink from './Link.style.js';

const Link = (_ref) => {
  let {
    href,
    asPath,
    children,
    transform,
    icon,
    variant,
    component
  } = _ref,
      props = _objectWithoutProperties(_ref, ["href", "asPath", "children", "transform", "icon", "variant", "component"]);

  return /*#__PURE__*/React$1.createElement(StyledLink, _extends({
    href: href,
    asPath: asPath,
    transform: transform,
    icon: icon,
    variant: variant,
    component: component
  }, props), children, icon && /*#__PURE__*/React$1.createElement(CssIcon, {
    icon: icon
  }));
};

Link.propTypes = {
  component: PropTypes$1.oneOfType([PropTypes$1.node, PropTypes$1.element, PropTypes$1.string]),
  href: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape()]),
  asPath: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape()]),
  children: PropTypes$1.node,
  transform: PropTypes$1.oneOf(['uppercase', 'lowercase', 'none']),
  icon: PropTypes$1.string,
  variant: PropTypes$1.string
};
Link.defaultProps = {
  component: null,
  href: '',
  asPath: '',
  children: null,
  transform: 'none',
  icon: null,
  variant: 'copy'
};

export default Link;
